import { action } from '@ember/object';
import { debounceTask } from 'ember-lifeline';
import Component from '@glimmer/component';

export default class WizardSearchComponent extends Component {
  intermediateValue = this.args.value ?? '';

  get _delay() {
    const delay = +this.args?.delay;
    if (isNaN(delay) || delay < 0) return 200;
    return delay;
  }

  get onSearch() {
    return this.args?.onSearch ?? function () {};
  }

  @action
  propagateTextChange() {
    try {
      debounceTask(this, 'onSearch', this.intermediateValue, this._delay);
    } catch (err) {
      console.log(err);
    }
  }

  @action
  setIntermediateValue(e) {
    this.intermediateValue = e.target.value;
  }
}
